import { type PropsWithChildren } from '@shared/utils';
import { createContext, useCallback, useMemo, useState } from 'react';

import { AlternativeRegistrationModalLogic } from '../../containers';
import { AlternativeForeignerRegistrationModalLogic } from '../../containers/alternative-foreigner-registration-modal-logic';

import type {
  AlternativeRegistrationModalContextValue,
  AlternativeRegistrationModalSetActionType,
} from './types';

const AlternativeRegistrationModalContext = createContext<
  AlternativeRegistrationModalContextValue | undefined
>(undefined);

export default function AlternativeRegistrationModalProvider(props: Readonly<PropsWithChildren>) {
  const { children } = props;
  const [action, setAction] = useState<AlternativeRegistrationModalSetActionType>({ type: null });

  const handleSetAction = useCallback(
    (action: AlternativeRegistrationModalSetActionType) => {
      setAction(action);
    },
    [setAction],
  );

  const handleClose = useCallback(() => {
    setAction({ type: null });
  }, []);

  const contextValue: AlternativeRegistrationModalContextValue = useMemo(() => {
    return {
      setAction: handleSetAction,
      close: handleClose,
    };
  }, [handleSetAction, handleClose]);

  return (
    <AlternativeRegistrationModalContext.Provider value={contextValue}>
      {children}
      <AlternativeRegistrationModalLogic
        open={action.type === 'register-examinee-with-alternative-document'}
        onClose={handleClose}
        examEventExamineeId={
          action.type === 'register-examinee-with-alternative-document'
            ? action.examEventExamineeId
            : ''
        }
      />
      <AlternativeForeignerRegistrationModalLogic
        open={action.type === 'register-foreigner-examinee-with-alternative-document'}
        onClose={handleClose}
        examEventExamineeId={
          action.type === 'register-foreigner-examinee-with-alternative-document'
            ? action.examEventExamineeId
            : ''
        }
      />
    </AlternativeRegistrationModalContext.Provider>
  );
}

export { AlternativeRegistrationModalContext };
